import { TypeOptions, toast } from 'react-toastify';

/**
 *  The "doing something… → done / failed" toast pair that the Backbone admin
 *  tool got from $.notify plus its closeNotify helper.
 */
export interface PendingToast {
  succeed: (message: string) => void;
  fail: (message: string) => void;
}

export const pendingToast = (message: string): PendingToast => {
  const toastId = Date.now() + Math.floor(Math.random() * 100);
  toast(message, {
    toastId,
    type: toast.TYPE.INFO,
    autoClose: false,
    closeButton: false,
    hideProgressBar: true,
    closeOnClick: false,
  });

  const settle = (type: TypeOptions) => (render: string) => {
    toast.update(toastId, { type, render });
    setTimeout(() => toast.dismiss(toastId), 3000);
  };

  return {
    succeed: settle(toast.TYPE.SUCCESS),
    fail: settle(toast.TYPE.ERROR),
  };
};
